<!-- Messages Area -->
<div class="chat-messages fade-in">
  <app-message-container
    [messages]="filteredMessages"
    [showWelcomeMessage]="showWelcomeMessage"
    [welcomeMessage]="welcomeMessage"
    [activeMessageId]="activeMessageId"
    [copiedMessageId]="copiedMessageId"
    [exportedMessageId]="exportedMessageId"
    (welcomeClick)="handleWelcomeClick($event)"
    (copySuccess)="onCopySuccess($event)"
    (exportSuccess)="onExportSuccess($event)"
    (exportError)="onExportError($event)"
    (messageEnter)="onMessageEnter($event)"
    (messageLeave)="onMessageLeave()"
    (messageClick)="onMessageClick($event)"
    (messageMouseDown)="onMessageMouseDown($event)"
    (messageMouseUp)="onMessageMouseUp($event)"
    (deleteFile)="removeFile($event)"
  ></app-message-container>

  <app-typing-indicator
    [visible]="showTypingIndicator"
    [message]="typingMessage"
  ></app-typing-indicator>
</div>
